module.exports = __webpack_public_path__ + "VIPV12.png?2b2d500eb0fb334bd885678dc6fcdbfd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV12.png
// module id = 106
// module chunks = 0